import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import {
    Modal,
    ModalContent,
} from 'yurstrap';

import { getLocationSelector } from '../../commons/selectors/RouterSelector';

import CMPModalContent from './CMPModalContent';

const propTypes = {
    location: PropTypes.object.isRequired,
};

export class CMPModal extends Component {

    render() {
        const { location } = this.props;
        if (!location || !location.pathname) return null;
        return (
            <Modal>
                <ModalContent
                    width="xl"
                >
                    <CMPModalContent location={location} />
                </ModalContent>
            </Modal>
        );
    }

}

CMPModal.propTypes = propTypes;

function mapStateToProps(state, ownProps) {
    return {
        location: ownProps.location || getLocationSelector(state),
    };
}

export default connect(mapStateToProps)(CMPModal);
